import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";

export interface ErrorListProps {
    errors: string[];
}

export default function ErrorList(props: ErrorListProps): JSX.Element {

    return (<>
        {props.errors && props.errors.length > 0 && <Container>
            <div>Errors:</div>
            {props.errors.map((errorStr, index) => <div key={index}>{errorStr}</div>)}
        </Container>}
    </>);
}

const Container = styled.pre`
    position: relative;
    color: red;
    font-size: 0.9em;
    white-space: pre-wrap;
    line-height: 1.45;
`;
